export var TileType;

(function (TileType) {
  TileType["center"] = "centeredIcon";
  TileType["inLine"] = "inlineIcon";
})(TileType || (TileType = {}));